import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function TruckIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox={'0 0 35.41 26.144'} fontSize={'inherit'} {...props}>
      <path
        id="Tracé_44"
        data-name="Tracé 44"
        d="M7.826,26.144a4.72,4.72,0,0,1-3.411-1.393,4.594,4.594,0,0,1-1.449-3.37H2.732a2.947,2.947,0,0,1-1.988-.937A2.972,2.972,0,0,1,0,18.37V3.011A2.893,2.893,0,0,1,.907.914,2.877,2.877,0,0,1,3.011,0H22.765a2.53,2.53,0,0,1,2.024.935,4.291,4.291,0,0,1,.986,2.076V6.589h3.508a1.684,1.684,0,0,1,.7.146,1.189,1.189,0,0,1,.513.437l4.635,6.1a2.27,2.27,0,0,1,.2.422,1.513,1.513,0,0,1,.083.508v5.684a1.459,1.459,0,0,1-1.5,1.494h-1.55a4.588,4.588,0,0,1-1.447,3.38,4.728,4.728,0,0,1-3.407,1.383,4.81,4.81,0,0,1-4.829-4.763H12.669a4.592,4.592,0,0,1-1.445,3.38,4.713,4.713,0,0,1-3.4,1.383m0-2.805a1.975,1.975,0,0,0,1.456-.611,2.058,2.058,0,0,0,0-2.916,2.044,2.044,0,0,0-2.917,0,2.07,2.07,0,0,0,1.462,3.528M3.011,3.011V18.37h.956a5.311,5.311,0,0,1,1.7-1.48,4.378,4.378,0,0,1,2.114-.526,4.285,4.285,0,0,1,2.128.555,5.98,5.98,0,0,1,1.72,1.452H22.765V3.011Zm24.5,20.328a1.975,1.975,0,0,0,1.456-.611,2.044,2.044,0,1,0-1.456.611m-1.733-8.244h6.91L28.551,9.609H25.775Z"
        transform="translate(0 0)"
        fill="#333"
      />
    </SvgIcon>
  );
}
